export const getDateFromDaysAgo = (daysAgo: number): string => {
    const currentDate = new Date()
    currentDate.setDate( currentDate.getDate() - daysAgo )
    return currentDate.toISOString()
}